import { render, staticRenderFns } from "./AboutHeader.vue?vue&type=template&id=07b664c3&"
import script from "./AboutHeader.vue?vue&type=script&lang=js&"
export * from "./AboutHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports